import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Compass, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/App";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) { setStatus("error"); setMessage("Missing verification token."); return; }
    fetch(`${API}/auth/verify-email`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    }).then(async res => {
      const data = await res.json();
      if (res.ok) { setStatus("success"); setMessage(data.message); }
      else { setStatus("error"); setMessage(data.detail || "Verification failed."); }
    }).catch(() => { setStatus("error"); setMessage("Something went wrong. Please try again."); });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="verify-email-page">
        <div className="w-12 h-12 rounded-xl bg-purple-700 flex items-center justify-center mx-auto mb-6"><Compass className="w-6 h-6 text-white" /></div>
        {status === "verifying" && (<><Loader2 className="w-10 h-10 text-purple-400 animate-spin mx-auto mb-4" /><h1 className="font-inter font-bold text-xl">Verifying your email…</h1></>)}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-neon mx-auto mb-4" />
            <h1 className="font-inter font-bold text-xl mb-2" data-testid="verify-success">Email verified!</h1>
            <p className="text-white/50 text-sm mb-6">Your account is fully activated. You can now upgrade to any paid plan.</p>
            <Link to="/dashboard"><Button className="bg-purple-700 text-white hover:bg-purple-600">Go to Dashboard</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h1 className="font-inter font-bold text-xl mb-2" data-testid="verify-error">Verification failed</h1>
            <p className="text-white/50 text-sm mb-6">{message}</p>
            <Link to="/dashboard"><Button variant="outline" className="border-white/20">Go to Dashboard</Button></Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
